import ens from "../../images/ens-grey.png";
import ud from "../../images/ud-grey.png";
import sl from "../../images/sl-grey.png";
import gd from "../../images/gd-grey.png";
import mail from "../../images/mail.png";
import globe from "../../images/globe.png";
import web2 from "../../images/web2.svg";
import userid from "../../images/userid.png";
import icann from "../../images/icann.png";

export const closeButton = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6L18 18"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const closeButtonDark = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4L4 12"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 4L12 12"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const clock = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3887_8016)">
      <path
        d="M8.00016 14.6668C11.6821 14.6668 14.6668 11.6821 14.6668 8.00016C14.6668 4.31826 11.6821 1.3335 8.00016 1.3335C4.31826 1.3335 1.3335 4.31826 1.3335 8.00016C1.3335 11.6821 4.31826 14.6668 8.00016 14.6668Z"
        stroke="black"
        strokeOpacity="0.7"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 4V8L10.6667 9.33333"
        stroke="black"
        strokeOpacity="0.7"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3887_8016">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const backbutton = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0303 3.96967C13.3232 4.26256 13.3232 4.73744 13.0303 5.03033L8.56066 9.5L13.0303 13.9697C13.3232 14.2626 13.3232 14.7374 13.0303 15.0303C12.7374 15.3232 12.2626 15.3232 11.9697 15.0303L6.96967 10.0303C6.67678 9.73744 6.67678 9.26256 6.96967 8.96967L11.9697 3.96967C12.2626 3.67678 12.7374 3.67678 13.0303 3.96967Z"
      fill="black"
    />
  </svg>
);

export const poweredBy = (
  <div style={{ alignItems: "center", height: 15, flex: "0 0 auto" }}>
    <svg
      width="138"
      height="14"
      viewBox="0 0 138 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.49 11V3.3H4.68C6.286 3.3 7.232 4.158 7.232 5.566C7.232 6.985 6.286 7.854 4.68 7.854H2.59V11H1.49ZM2.59 6.831H4.636C5.582 6.831 6.11 6.369 6.11 5.566C6.11 4.785 5.582 4.334 4.636 4.334H2.59V6.831ZM10.3673 11.154C8.76126 11.154 7.63926 10.032 7.63926 8.349C7.63926 6.677 8.76126 5.555 10.3673 5.555C11.9843 5.555 13.0953 6.677 13.0953 8.349C13.0953 10.032 11.9843 11.154 10.3673 11.154ZM8.73926 8.349C8.73926 9.449 9.39926 10.186 10.3673 10.186C11.3463 10.186 11.9953 9.449 11.9953 8.349C11.9953 7.26 11.3463 6.523 10.3673 6.523C9.39926 6.523 8.73926 7.26 8.73926 8.349ZM15.1749 11L13.5359 5.709H14.6469L15.8239 9.812L17.0009 5.709H18.2219L19.3989 9.812L20.5759 5.709H21.6869L20.0479 11H18.7939L17.6169 6.919L16.4289 11H15.1749ZM24.7387 11.154C23.1547 11.154 22.0987 10.043 22.0987 8.327C22.0987 6.622 23.1547 5.555 24.6617 5.555C26.2347 5.555 27.2027 6.578 27.2027 8.195C27.2027 8.338 27.1917 8.481 27.1697 8.701H23.1547C23.1987 9.669 23.7927 10.252 24.7387 10.252C25.3657 10.252 25.8057 9.966 26.0147 9.493H27.1037C26.7737 10.516 25.9597 11.154 24.7387 11.154ZM23.1547 7.865H26.1247V7.81C26.1247 6.996 25.5967 6.413 24.6617 6.413C23.7707 6.413 23.1987 7.007 23.1547 7.865ZM28.268 11V5.709H29.214V6.567C29.346 6.039 29.742 5.709 30.369 5.709H31.381V6.644H30.27C29.61 6.644 29.335 7.018 29.335 7.733V11H28.268ZM34.1707 11.154C32.5867 11.154 31.5307 10.043 31.5307 8.327C31.5307 6.622 32.5867 5.555 34.0937 5.555C35.6667 5.555 36.6347 6.578 36.6347 8.195C36.6347 8.338 36.6237 8.481 36.6017 8.701H32.5867C32.6307 9.669 33.2247 10.252 34.1707 10.252C34.7977 10.252 35.2377 9.966 35.4467 9.493H36.5357C36.2057 10.516 35.3917 11.154 34.1707 11.154ZM32.5867 7.865H35.5567V7.81C35.5567 6.996 35.0287 6.413 34.0937 6.413C33.2027 6.413 32.6307 7.007 32.5867 7.865ZM39.8889 11.154C38.3819 11.154 37.3479 10.032 37.3479 8.349C37.3479 6.677 38.3819 5.555 39.8889 5.555C40.6589 5.555 41.2859 5.841 41.6159 6.358V3.3H42.6719V11H41.7259V10.263C41.3739 10.824 40.7139 11.154 39.8889 11.154ZM38.4479 8.349C38.4479 9.449 39.0969 10.186 40.0539 10.186C41.0109 10.186 41.6379 9.449 41.6379 8.349C41.6379 7.26 41.0109 6.523 40.0539 6.523C39.0969 6.523 38.4479 7.26 38.4479 8.349ZM49.5392 11.154C48.7142 11.154 48.0432 10.824 47.7022 10.241V11H46.7562V3.3H47.8232V6.347C48.1642 5.841 48.7802 5.555 49.5392 5.555C51.0462 5.555 52.0802 6.677 52.0802 8.349C52.0802 10.032 51.0462 11.154 49.5392 11.154ZM47.8012 8.349C47.8012 9.449 48.4282 10.186 49.3852 10.186C50.3422 10.186 50.9802 9.449 50.9802 8.349C50.9802 7.26 50.3422 6.523 49.3852 6.523C48.4282 6.523 47.8012 7.26 47.8012 8.349ZM52.4315 12.98V12.023H53.3775C53.7405 12.023 53.9055 11.913 54.0265 11.638L54.4885 10.637L52.2665 5.709H53.4875L55.0495 9.438L56.6115 5.709H57.8105L54.9065 12.166C54.6645 12.716 54.3565 12.98 53.6195 12.98H52.4315Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M72.6548 8.17516C72.6548 9.85762 71.2668 11.2215 69.5546 11.2215H66.9033C63.902 11.2215 61.5 8.7404 61.5 5.82511C61.5 2.90983 63.902 0.428711 66.9033 0.428711L70.0478 0.428711V1.82133L66.9033 1.82133C64.7189 1.82133 62.9172 3.64496 62.9172 5.82511C62.9172 8.00527 64.7189 9.8289 66.9033 9.8289H69.5546C70.4841 9.8289 71.2376 9.08849 71.2376 8.17516C71.2376 7.26183 70.4841 6.52142 69.5546 6.52142H66.9858C66.5944 6.52142 66.2772 6.20968 66.2772 5.82511C66.2772 5.44055 66.5944 5.1288 66.9858 5.1288H69.5546C71.2668 5.1288 72.6548 6.49271 72.6548 8.17516Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M63.8976 5.82512C63.8976 4.14266 65.2857 2.77876 66.9979 2.77876H69.6492C72.6504 2.77876 75.0524 5.25988 75.0524 8.17516C75.0524 11.0904 72.6504 13.5716 69.6492 13.5716H66.5047V12.1789H69.6492C71.8335 12.1789 73.6352 10.3553 73.6352 8.17516C73.6352 5.99501 71.8335 4.17138 69.6492 4.17138H66.9979C66.0684 4.17138 65.3149 4.91178 65.3149 5.82512C65.3149 6.73845 66.0684 7.47885 66.9979 7.47885H69.5666C69.958 7.47885 70.2753 7.7906 70.2753 8.17516C70.2753 8.55972 69.958 8.87147 69.5666 8.87147H66.9979C65.2857 8.87147 63.8976 7.50757 63.8976 5.82512Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M81.1938 11.246C83.2301 11.246 84.4542 10.1585 84.4542 8.50413C84.4542 7.03484 83.6185 6.225 81.9118 6.02833L81.0996 5.93577C80.2875 5.84322 79.9344 5.61184 79.9344 5.16064C79.9344 4.72101 80.4052 4.42021 81.0996 4.42021C81.8647 4.42021 82.3355 4.72101 82.3708 5.23006H84.3365C84.3012 3.72607 83.1241 2.75426 81.0996 2.75426C79.2282 2.75426 77.9334 3.7492 77.9334 5.2879C77.9334 6.65306 78.7456 7.49761 80.4876 7.70586L81.3821 7.80998C82.1354 7.90253 82.4415 8.14548 82.4415 8.63139C82.4415 9.19828 81.9589 9.54535 81.1938 9.54535C80.2875 9.54535 79.699 9.12886 79.6754 8.48099H77.7098C77.7333 10.2164 79.0398 11.246 81.1938 11.246Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M88.5467 11.246C90.6065 11.246 91.8777 10.0081 91.8777 8.00665V2.95093H89.9356V7.85625C89.9356 8.90905 89.4177 9.4528 88.5467 9.4528C87.6757 9.4528 87.1578 8.90905 87.1578 7.85625V2.95093H85.2157V8.00665C85.2157 10.0081 86.4869 11.246 88.5467 11.246Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M92.8199 11.0493H94.762V8.22647H96.4923C98.246 8.22647 99.4113 7.23152 99.4113 5.5887C99.4113 3.94588 98.246 2.95093 96.4923 2.95093H92.8199V11.0493ZM94.762 6.43325V4.74415H96.3981C97.0572 4.74415 97.4457 5.07966 97.4457 5.5887C97.4457 6.09774 97.0572 6.43325 96.3981 6.43325H94.762Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M100.056 11.0493H105.506V9.25612H101.998V7.71742H105.506V5.9242H101.998V4.74415H105.506V2.95093H100.056V11.0493Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M106.333 11.0493H108.275V8.05293H108.84L110.924 11.0493H113.278L111.124 7.99508C112.301 7.68272 113.042 6.80346 113.042 5.53085C113.042 3.92274 111.877 2.95093 110.123 2.95093H106.333V11.0493ZM108.275 6.31756V4.74415H110.112C110.724 4.74415 111.077 5.05652 111.077 5.53085C111.077 6.00519 110.724 6.31756 110.112 6.31756H108.275Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M113.691 11.0493H119.199V9.25612H115.633V2.95093H113.691V11.0493Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M119.852 11.0493H121.794V2.95093H119.852V11.0493Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M122.738 11.0493H124.68V6.05147L127.293 11.0493H129.6V2.95093H127.658V7.94881L125.045 2.95093H122.738V11.0493Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M135.134 11.0493H137.5L134.451 6.74562L137.5 2.95093H135.146L132.839 5.84322H132.368V2.95093H130.426V11.0493H132.368V7.79841H132.898L135.134 11.0493Z"
        fill="black"
        fillOpacity="0.3"
      />
    </svg>
  </div>
);

export const searchButton = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9996 14.0001L11.0996 11.1001"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const plus = (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 4V14"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33325 9H12.6666"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const minus = (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33325 9H12.6666"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const superlinklogo = (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.58467 4.71523C6.58467 5.73934 5.76533 6.56954 4.75461 6.56954H3.18954C1.41793 6.56954 -1.53106e-07 5.05929 0 3.28477C1.53106e-07 1.51025 1.41793 -1.56931e-07 3.18954 0L5.04575 1.64424e-07V0.847682L3.18954 0.847682C1.90013 0.847682 0.836601 1.95772 0.836601 3.28477C0.836601 4.61182 1.90013 5.72185 3.18954 5.72185H4.75461C5.30328 5.72185 5.74807 5.27117 5.74807 4.71523C5.74807 4.15929 5.30328 3.70861 4.75461 3.70861H3.23827C3.00725 3.70861 2.81997 3.51885 2.81997 3.28477C2.81997 3.05069 3.00725 2.86093 3.23827 2.86093H4.75461C5.76533 2.86093 6.58467 3.69113 6.58467 4.71523Z"
      fill="white"
    />
    <path
      d="M1.41533 3.28477C1.41533 2.26067 2.23467 1.43046 3.24539 1.43046H4.81046C6.58207 1.43046 8 2.94071 8 4.71523C8 6.48975 6.58207 8 4.81046 8H2.95425V7.15232H4.81046C6.09987 7.15232 7.1634 6.04228 7.1634 4.71523C7.1634 3.38818 6.09987 2.27815 4.81046 2.27815H3.24539C2.69672 2.27815 2.25193 2.72883 2.25193 3.28477C2.25193 3.84071 2.69672 4.29139 3.24539 4.29139H4.76173C4.99275 4.29139 5.18003 4.48115 5.18003 4.71523C5.18003 4.94931 4.99275 5.13907 4.76173 5.13907H3.24539C2.23467 5.13907 1.41533 4.30887 1.41533 3.28477Z"
      fill="white"
    />
  </svg>
);

export const icannLogo = <img width={16} height={16} src={icann} />;
export const ensLogo = <img width={16} height={16} src={ens} />;
export const slLogo = <img width={16} height={16} src={sl} />;
export const gdLogo = <img width={16} height={16} src={gd} />;
export const udLogo = <img width={16} height={16} src={ud} />;
export const emailLogo = <img width={16} height={16} src={mail} />;
export const userLogo = <img width={16} height={16} src={userid} />;
export const globeLogo = <img width={16} height={16} src={globe} />;
export const web2Logo = <img width={16} height={16} src={web2} />;

export const rightArrow = (color: string) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.96967 16.0303C6.67678 15.7374 6.67678 15.2626 6.96967 14.9697L11.4393 10.5L6.96967 6.03033C6.67678 5.73744 6.67678 5.26256 6.96967 4.96967C7.26256 4.67678 7.73744 4.67678 8.03033 4.96967L13.0303 9.96967C13.3232 10.2626 13.3232 10.7374 13.0303 11.0303L8.03033 16.0303C7.73744 16.3232 7.26256 16.3232 6.96967 16.0303Z"
      fill={color}
      fillOpacity="0.3"
    />
  </svg>
);

export const tick = (
  <svg
    width="16"
    height="12"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 0.875L4.75 9.125L1 5.375"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const smallArrow = (
  <svg
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.681851 0.4819C0.857587 0.306164 1.14251 0.306164 1.31825 0.4819L4.00005 3.1637L6.68185 0.4819C6.85759 0.306164 7.14251 0.306164 7.31825 0.4819C7.49398 0.657635 7.49398 0.942559 7.31825 1.1183L4.31825 4.11829C4.14251 4.29403 3.85759 4.29403 3.68185 4.11829L0.681851 1.1183C0.506115 0.942559 0.506115 0.657635 0.681851 0.4819Z"
      fill="black"
    />
  </svg>
);